<template>
  <div class="contiguity-list">
    Powierzchnie dodatkowe: <br>
    <div v-if="hasAdditionalAreas">
      <div v-if="item.balkon">Balkon: {{ item.balkon }} m²</div>
      <div v-if="item.taras">Taras: {{ item.taras }} m²</div>
      <div v-if="item.loggia">Loggia: {{ item.loggia }} m²</div>
      <div v-if="item.ogrod">Ogród: {{ item.ogrod }} m²</div>
      <div
        v-for="cont in item.contiguity_list?.contiguity || []"
        :key="cont.contiguity_id"
      >
        {{ cont.contiguity_name }} – {{ cont.contiguity_type }}
        <span v-if="cont.contiguity_area && Number(cont.contiguity_area) > 0">
          ({{ cont.contiguity_area }} m²)
        </span>
      </div>
    </div>
    <div v-else>
      Brak powierzchni dodatkowych
    </div>
  </div>
</template>

<script>
export default {
  name: "ContiguityListSimple",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasAdditionalAreas() {
      return (
         (this.item.balkon && String(this.item.balkon).trim() !== "" && this.item.balkon !== "0") ||
      (this.item.taras && String(this.item.taras).trim() !== "" && this.item.taras !== "0") ||
      (this.item.loggia && String(this.item.loggia).trim() !== "" && this.item.loggia !== "0") ||
      (this.item.ogrod && String(this.item.ogrod).trim() !== "" && this.item.ogrod !== "0") ||
      (this.item.contiguity_list?.contiguity?.length > 0)
      );
    }
  }
};
</script>

<style scoped>
.contiguity-list {
  margin-top: 0;
}
</style>